module.exports = __webpack_public_path__ + "static/media/aeg.d768a7a7.png";